/**
 * Sentry — Frontend Initialization
 *
 * Must be imported BEFORE any other module in main.tsx.
 * Only active in production builds (enabled: import.meta.env.PROD).
 */

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,               // "development" or "production"
  enabled: import.meta.env.PROD,                    // Silent in dev — only reports in prod
  integrations: [
    Sentry.browserTracingIntegration(),              // Performance monitoring
    Sentry.replayIntegration(),                      // Session replay for debugging
  ],
  tracesSampleRate: 0.3,                            // 30% of transactions traced
  replaysSessionSampleRate: 0.1,                    // 10% of sessions recorded
  replaysOnErrorSampleRate: 1.0,                    // 100% of error sessions recorded
});
